// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".completedToDoPnl{max-height:500px;width:500px}.completedToDoPnl.container{padding:0}", ""]);
// Exports
module.exports = exports;
